import React, { memo, useCallback } from 'react';
import PropTypes from 'prop-types';

import ChevronDownIcon from 'static/images/sidebar/chevron-down.svg';
import DispatchMenuIcon from 'static/images/sidebar/dispatching.svg';
import MaintenanceMenuIcon from 'static/images/sidebar/maintenance.svg';
import SystemSettingsMenuIcon from 'static/images/sidebar/system_settings.svg';
import ToolsMenuIcon from 'static/images/sidebar/tools.svg';
import IntegrationMenuIcon from 'static/images/sidebar/add_ons.svg';

import SubMenuItem from './SubMenuItem';

import { getResourceTo } from 'react/utils/utils';
import { useMenus, useSidebar } from 'react/hooks/sidebar.hook';

function MenuItem({ id, active, name, submenus }) {
  const { setActiveMenu } = useMenus();
  const { isCollapsed, isHovered } = useSidebar();

  const item = {
    id, 
    active, 
    name, 
    submenus
  };

  function getMenuIcon(iconName) {
    switch (iconName) {
      case 'topMenu.dispatchingLive':
        return DispatchMenuIcon;
      case 'topMenu.maintenance':
        return MaintenanceMenuIcon;
      case 'topMenu.systemSettings':
        return SystemSettingsMenuIcon;
      case 'topMenu.tools':
        return ToolsMenuIcon;
      case 'topMenu.3rdparty':
        return IntegrationMenuIcon;
      default:
        return DispatchMenuIcon;
    }
  }

  const handleClick = useCallback(() => {
    if (!isHovered && isCollapsed) {
      return;
    }

    setActiveMenu(item);
  }, [isHovered, isCollapsed, setActiveMenu, item]);
  
  return (
    <li
      key={id}
      className={active ? 'dropdown-opened' : ''}
    >
      <div 
        onClick={handleClick}
        className="menu-item-content"
        data-testid={`${name}-menu`}
      >
        <div className="text-and-icon">
          <img src={getMenuIcon(name)} alt={`${name} Icon`} />
          <p>{getResourceTo(name)}</p>
        </div>
        <img src={ChevronDownIcon} alt="" />
      </div>
      <ul className="submenu">
        {!!active && submenus.map((subMenuItem) => (
          <SubMenuItem
            key={subMenuItem.name}
            {...subMenuItem}
          />
        ))}
      </ul>
    </li>
  );
}

MenuItem.propTypes = {
  id: PropTypes.number.isRequired, 
  active: PropTypes.bool.isRequired, 
  name: PropTypes.string.isRequired, 
  submenus: PropTypes.array.isRequired
};

export default memo(MenuItem);